import type {RUnit, ResponsiveRectangleOptions} from './types';
import {calcResponsiveUnits} from './utils';
import {Rectangle} from 'pixi.js';

export class RRectangle {
    static from(data: ResponsiveRectangleOptions): RRectangle {
        return new RRectangle(data.x, data.y, data.width, data.height);
    }

    constructor(
        public x: RUnit = '0',
        public y: RUnit = '0',
        public width: RUnit = '100%',
        public height: RUnit = '100%',
    ) {}

    calcToPixiRectangle(context: Rectangle, result: Rectangle): void {
        result.x = calcResponsiveUnits(context.width, this.x);
        result.y = calcResponsiveUnits(context.height, this.y);
        result.width = calcResponsiveUnits(context.width, this.width);
        result.height = calcResponsiveUnits(context.height, this.height);
    }
}